// Dashboard.js
import React, { useEffect, useState, useContext } from 'react';
import './Dashboard.css';
import Navbar from './components/Navbar';
import { AuthContext } from './AuthContext';
import api from './api';

function Dashboard() {
  const { token, isAuthenticated } = useContext(AuthContext);
  const [bills, setBills] = useState([]);

  useEffect(() => {
    if (!isAuthenticated || !token) return;

    const fetchData = async () => {
      try {
        const response = await api.get('/bills/');
        setBills(response.data);
      } catch (error) {
        console.error('Error fetching bills:', error);
      }
    };

    fetchData();
  }, [isAuthenticated, token]);

  return (
    <div className="dashboard">
      <Navbar />
      <div className="content">
        <h1>Dashboard</h1>
        <ul>
          {bills.map((bill) => (
            <li key={bill.id}>
              {bill.description} - {bill.amount}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Dashboard;
